import { api, Methods } from 'services/api';
import { CalendarResponse } from '@solin-fitness/types';

export const getWorkoutDropCalendar = async () =>
  await api<CalendarResponse[]>(
    Methods.get,
    '/calendar?weeks_back=0&weeks_forward=5',
  );
